import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, TextField, CircularProgress } from '@mui/material';
import { useAuth} from './AuthProvider';
import PasswordInput from './components/PasswordInput';
import {ErrorCatcher} from './components/ErrorCatcher';
import { useNavigate } from 'react-router-dom';


const SubmitCredentials = ({onSuccess, closeModal, embedded, email, password}) => {
  const { register, send_confirmation } = useAuth();
  const navigate = useNavigate();
  const [errorObj, setErrorObj] = useState(null);
  const [msg, setMsg] = useState(null);
  
  const [isCloseButton, setIsCloseButton] = useState(false);
  const [waitingEmailConfirm, setWaitingEmailConfirm] = useState(false);
  const [dontClickSubmit, setDontClickSubmit] = useState(false);

  const [isSignUpSuccess, setIsSignUpSuccess] = useState(false);  
  const [isLoginVisible, setIsLoginVisible] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });  
  
  useEffect(() => {
    if (email) {
      setFormData(prev => ({
        ...prev,
        email: email,
      }));
    }

    if (password) {
      setFormData(prev => ({
        ...prev,
        password: password,
      }));
    }
  }, [email, password]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrorObj(null);
  };

  const handlePasswordChange = (e) => {
    const pw = e.target.value;
    setFormData((prev) => ({
      ...prev,
      password: pw,
    }));
  };

  const paperbgkColor = () => {
    if (embedded) {
      return 'primary';
    } else {
      return 'cornsilk';
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorObj(null);
    setIsCloseButton(false);
    setDontClickSubmit(true);
    try {
      // Trim inputs
      const trimmedFormData = {
         ...formData,
         name: formData.name.trim(),
         email: formData.email.trim(),
         password: formData.password.trim(),
       };

      const res = await register(trimmedFormData);
      console.log(res);

      if (res) {
        setIsSignUpSuccess(true);
        setWaitingEmailConfirm(true);
        const confirmation_msg = await send_confirmation(trimmedFormData.email);
        setWaitingEmailConfirm(false);
        setMsg(confirmation_msg);
        console.log(confirmation_msg);
        setIsCloseButton(true);
        if (onSuccess) {
          onSuccess({ 'email': trimmedFormData.email, 'password': trimmedFormData.password });
        }
      }
    } catch (error) {
      console.error('In SubmitCreds:', error);
      setErrorObj(error);
    } finally {
      setDontClickSubmit(false);
      setWaitingEmailConfirm(false);
    }
  };
  
  const callBackClose = {
    '4019': () => { setDontClickSubmit(false);                  
    },
    '5012': () => { navigate('/login'); },
  };
  const callBackOpen = {
    '4019': () => { setDontClickSubmit(true); 
                    setIsLoginVisible(true);
    },
  };

  return (
    <Box
      sx={{
        // bgcolor: 'cornsilk',
        bgcolor: paperbgkColor(),
        color: 'blue',
        // width: '400px',
        p: 3,
        borderRadius: '10px',
      }}
    >
      <Typography variant="h5" id="account-modal-title" gutterBottom>
        Create Account
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          name="email"
          type="email"
          fullWidth
          margin="dense"
          value={formData.email}
          onChange={handleChange}
          autoComplete="email"
          required
          sx={{ mb: 2 }}
        />
        <TextField
          label="Name"
          name="name"
          fullWidth
          margin="dense"
          value={formData.name}
          onChange={handleChange}
          autoComplete="username"
          required
          sx={{ mb: 2 }}
        />
        <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
          {/* <Typography variant="body1" sx={{ marginRight: 1 }}>
            Password:
          </Typography> */}
          <PasswordInput
            value={formData.password}
            onChange={handlePasswordChange}
            placeholder="Create password *"
            name="password"
            id="password"
            eyeshift="-20px"
          />
        </Box>
        {isSignUpSuccess && (
          <Typography variant="outlined" sx={{ mb: 2 }}>
            Your account has been created
          </Typography>
        )}
        <Box>
          {waitingEmailConfirm ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              {msg && (
                <Box>
                  <Typography>{msg}</Typography>
                  <Typography variant="outlined" sx={{ mb: 2, color: 'black' }}>
                    Please check your inbox and <span style={{ color: 'red', fontWeight: 'bold' }}>SPAM folder</span> for the email from speaknoaccents.com
                  </Typography>
                  <Typography variant="outlined" sx={{ mb: 2, color: 'black' }}>
                    {" and click the confirmation link"}
                  </Typography>
                </Box>
              )}

              {errorObj && (
                <ErrorCatcher
                  error={errorObj}
                  resetError={() => { setErrorObj(null); }}
                  callBackMapOpen={callBackOpen}
                  callBackMapClose={callBackClose}
                ></ErrorCatcher>
              )}
            </Box>
          )}
        </Box>
        {!(embedded && isCloseButton) && (
          <Box>
            <Button
              type="button"
              variant="contained"
              color="primary"
              disabled={dontClickSubmit || ((isSignUpSuccess || waitingEmailConfirm) && !isCloseButton)}
              onClick={isCloseButton ? closeModal : handleSubmit}
              sx={{ mr: 1, mt: 2 }}
            >
              {isCloseButton ? 'Close' : 'Submit'}
            </Button>
            { isLoginVisible && 
                        <Button
              sx={{ mr: 1, mt: 2 }}
              variant="contained"
              onClick={() => navigate('/login')}
            >
              Navigate To Login
            </Button> }
          </Box>
        )}
      </form>
    </Box>
  );
};

export default SubmitCredentials;